import React, {useContext, useState} from "react";
import hipaaReleaseRequestsApi from "../../../../api/hipaaReleaseRequestsApi";
import {buyNowContext} from "../BuyNow";

function ParentChildHIPAARelease() {
  const { shippingStageState, order } = useContext(buyNowContext);
  
  const [hipaaState, setHipaaState] = useState("");
  const [parentEmail, setParentEmail] = useState(shippingStageState.email || "");
  const [hipaaSubmitting, setHipaaSubmitting] = useState(false);
  const [hipaaResult, setHipaaResult] = useState(null);
  const [hipaaSent, setHipaaSent] = useState(false);
  const [childIsAdult, setChildIsAdult] = useState(null);

  const createHipaaRelease = async () => {
    if (!hipaaState || !parentEmail) {
      setHipaaResult({ ok: false, message: "Please select a state and confirm parent email." });
      return;
    }
    setHipaaSubmitting(true);
    setHipaaResult(null);
    try {
      await hipaaReleaseRequestsApi.create(order.id, hipaaState, parentEmail);
      setHipaaResult({ ok: true, message: "Medical release form has been sent!" });
      setHipaaSent(true);
    } catch (e) {
      const message = typeof e === "string" ? e : (e && e.error) || "Could not create Medical release form.";
      setHipaaResult({ ok: false, message });
    } finally {
      setHipaaSubmitting(false);
    }
  };

  return (
    <div className="offset-lg-2 col-lg-6 d-flex flex-column mt-3">
      <div className="sub-txt mb-2 text-center">
        <span className="fw-bold sub-txt">Is the individual who will be using MyClearStep 18 years of age or older?</span> If so, a signed medical release form is required before any health information may be disclosed.
      </div>

      <Button title={"Yes"} onClick={() => setChildIsAdult(true)} isSelected={childIsAdult === true} disabled={hipaaResult?.ok} />
      <Button title={"No"} onClick={() => setChildIsAdult(false)} isSelected={childIsAdult === false} disabled={hipaaResult?.ok} />

      {childIsAdult === false &&
        <div className="sub-txt fw-bold text-center">
          You're all set!
          <div className="sub-txt text-center">You do not need to sign a medical release form.</div>
        </div>
      }

      {childIsAdult && !hipaaSent && (
        <>
          <div className="text-start mb-2">
            <label className="sub-txt">Identify the location of the individual utilizing the product, as required under HIPAA compliance.</label>
            <select className="form-control description-txt" value={hipaaState} onChange={e => setHipaaState(e.target.value)}>
              <option className="description-txt" value="">Select state</option>
              {["alabama","alaska","arizona","arkansas","california","colorado","connecticut","delaware", "florida","georgia","hawaii","idaho","illinois","indiana","iowa","kansas","kentucky","louisiana","maine","maryland","massachusetts","michigan","minnesota","mississippi","missouri","montana","nebraska","nevada","new_hampshire","new_jersey","new_mexico","new_york","north_carolina","north_dakota","ohio","oklahoma","oregon","pennsylvania","rhode_island","south_carolina","south_dakota","tennessee","texas","utah","vermont","virginia","washington","west_virginia","wisconsin","wyoming"].map(s => (
                <option className="description-txt" key={s} value={s}>{s.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}</option>
              ))}
            </select>
          </div>
          <div className="text-start mb-3">
            <label className="sub-txt">Individual email</label>
            <input className="form-control description-txt" type="email" value={parentEmail} onChange={e => setParentEmail(e.target.value)} />
          </div>

          <Button title={hipaaSubmitting ? "Sending…" : "Send Medical Release Document"} disabled={hipaaSubmitting} onClick={createHipaaRelease} isSelected={true} />
        </>
      )}
      {hipaaResult && (
        <div className={`text-${hipaaResult.ok ? "success" : "danger"} mb-2 sub-txt text-center`}>{hipaaResult.message}</div>
      )}
      <a href="https://www.myclearstep.com/" className="next-button-txt text-center px-lg-3 mt-3 mb-3 align-self-center lg-100-sm-75" style={{ color: "var(--main-color)", textDecoration: "underline" }}>
        Back to home
      </a>
    </div>
  );
}

function Button({ title, disabled, onClick, isSelected }) {
  const toggleButtonClassName = "h-100 col-12 btn btn-outline-dark toggle-button-outline description-txt py-3 py-lg-2 mb-3 " + (isSelected ? 'clicked' : '');

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={toggleButtonClassName}
    >
      {title}
    </button>
  );
}

export default ParentChildHIPAARelease;